import jQuery from 'jquery'; // Required for Slick import.
import '@accessible360/accessible-slick';

(($) => {
  $(() => {
    const $gallery = $('.product-gallery');

    if ($gallery.length) {
      const slickSettings = {
        autoplay: false,
        arrows: false,
        dots: true,
        infinite: true,
        rows: 0,
      };

      $gallery.slick(slickSettings);
    }
  });
})(jQuery);
